import { Col, Container, Row } from 'react-bootstrap'
import { HowItWorksHeroContainer } from './style'
import { useTranslation } from 'react-i18next'

function HowItWorksHero() {
  const { t } = useTranslation()

  return (
    <HowItWorksHeroContainer>
      <Container className="h-100">
        <Row className="h-100">
          <Col lg={5} md={8} xs={8}>
            <div className="home-header-content">
              <h1>{t('how_header_title')}</h1>
            </div>
          </Col>
        </Row>
      </Container>
    </HowItWorksHeroContainer>
  )
}

export default HowItWorksHero
